import React from "react"
import { useTranslation } from "react-i18next"
import { Box, styled } from "@mui/material"

import Table from "components/ui/Table"
import { DATE_TYPE, MONEY_TYPE, STRING_TYPE } from "config"
import { SubscriptionPaymentType } from "types"

type Props = {
  items: SubscriptionPaymentType[]
}

const PaymentsComponent = ({ items }: Props) => {
  const { t } = useTranslation()
  const isPayments = items.length > 0

  const HEADER = [
    {
      label: t("features.subscription.payments.table.date"),
      field: "date",
      format: DATE_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.subscription.payments.table.amount"),
      field: "amount",
      format: MONEY_TYPE,
      minWidth: 100,
    },
    {
      label: t("features.subscription.payments.table.status"),
      field: "state",
      format: STRING_TYPE,
      minWidth: 100,
    },
  ]

  return (
    <>
      {isPayments && (
        <PaymentsList>
          <Table
            fade={false}
            header={HEADER}
            items={items.map((payment: SubscriptionPaymentType) => {
              return {
                ...payment,
                state: t(
                  `features.subscription.payments.state.${payment.state}.title`,
                ),
              }
            })}
          />
        </PaymentsList>
      )}
    </>
  )
}

PaymentsComponent.defaultProps = {
  invoices: [],
}

export default PaymentsComponent

const PaymentsList = styled(Box)(() => ({
  margin: "21px 0 0 0",
}))
